export const MODAL_CLASS_NAME = 'modal';

export const isModal = (x: HTMLElement) => {
    return x.classList.contains(MODAL_CLASS_NAME);
}
